module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-100.woff?ad37abfaab272d36dae659840954d1d6";